import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
    private imageSource = new BehaviorSubject<string>('');
    currentImage = this.imageSource.asObservable();

    changeImage(image: string) {
        // Emite a nova imagem apenas se for diferente da atual
        if (image !== this.imageSource.value) {
            this.imageSource.next(image);
        }
    }
}
